module.exports = __webpack_public_path__ + "static/media/29FUNOV13.ddfc602f.jpg";